/* MDD Premium Theme — minimal vanilla JS, no dependencies */
(function () {
  'use strict';

  /* ---------- Mobile nav drawer ---------- */
  var nav = document.getElementById('MobileNav');
  var openBtn = document.getElementById('MenuToggle');
  if (nav && openBtn) {
    var closeEls = nav.querySelectorAll('[data-nav-close]');
    var open = function () {
      nav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      openBtn.setAttribute('aria-expanded', 'true');
    };
    var close = function () {
      nav.classList.remove('is-open');
      document.body.style.overflow = '';
      openBtn.setAttribute('aria-expanded', 'false');
    };
    openBtn.addEventListener('click', open);
    closeEls.forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ---------- Product gallery thumbs ---------- */
  var mainImg = document.getElementById('GalleryMainImage');
  if (mainImg) {
    document.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-src') || btn.getAttribute('data-full');
        var srcset = btn.getAttribute('data-srcset');
        if (src) { mainImg.src = src; mainImg.removeAttribute('srcset'); }
        if (srcset) mainImg.srcset = srcset;
        mainImg.alt = btn.getAttribute('data-alt') || mainImg.alt;
        document.querySelectorAll('[data-thumb].is-active').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
      });
    });
  }

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('.qty-input').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    if (!input) return;
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = (btn.hasAttribute('data-qty-plus') || btn.getAttribute('data-step') === 'up') ? 1 : -1;
        var val = parseInt(input.value, 10) || 1;
        var next = Math.max(parseInt(input.min, 10) || 1, val + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- Sticky mobile add-to-cart ---------- */
  var sticky = document.getElementById('StickyAtc');
  var buyBox = document.getElementById('BuyBoxActions');
  if (sticky && buyBox && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '-70px 0px 0px 0px' });
    io.observe(buyBox);
    var stickyBtn = sticky.querySelector('[data-sticky-atc]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.getElementById('ProductForm');
        if (form) {
          var submit = form.querySelector('[type="submit"]');
          if (submit) submit.click();
          else form.submit();
        }
      });
    }
  }

  /* ---------- Variant selection ---------- */
  var variantData = document.getElementById('VariantData');
  var variantSelects = document.querySelectorAll('[data-variant-option]');
  if (variantData && variantSelects.length) {
    var variants = JSON.parse(variantData.textContent);
    var idInput = document.querySelector('#ProductForm input[name="id"]');
    var priceBlock = document.getElementById('PriceBlock');
    variantSelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var chosen = [];
        variantSelects.forEach(function (s) { chosen.push(s.value); });
        var match = variants.find(function (v) {
          return chosen.every(function (val, i) { return v.options[i] === val; });
        });
        if (match && idInput) {
          idInput.value = match.id;
          if (priceBlock) {
            var priceEl = priceBlock.querySelector('.price');
            if (priceEl) priceEl.textContent = (match.price / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD' });
          }
          var atcBtn = document.querySelector('#BuyBoxActions [name="add"]');
          if (atcBtn) {
            atcBtn.disabled = !match.available;
            atcBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
          }
        }
      });
    });
  }

  /* ---------- Cart line quantity auto-submit ---------- */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  /* ---------- Slim-on-scroll header ---------- */
  var hdr = document.getElementById('SiteHeader');
  if (hdr) {
    var onScroll = function () {
      hdr.classList.toggle('is-slim', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Count-up stats ---------- */
  var counters = document.querySelectorAll('[data-countup]');
  if (counters.length && 'IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        cio.unobserve(el);
        var target = parseInt(el.getAttribute('data-countup'), 10) || 0;
        var suffix = el.getAttribute('data-suffix') || '';
        var dur = 1200, start = null;
        var stepFn = function (ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          el.textContent = Math.floor(target * (1 - Math.pow(1 - p, 3))).toLocaleString() + suffix;
          if (p < 1) requestAnimationFrame(stepFn);
        };
        requestAnimationFrame(stepFn);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { cio.observe(el); });
  }

  /* ---------- Lazy image fade-in ---------- */
  document.querySelectorAll('img.lazy-fade').forEach(function (img) {
    if (img.complete && img.naturalWidth > 0) {
      img.classList.add('is-loaded');
    } else {
      img.addEventListener('load', function () { img.classList.add('is-loaded'); });
      img.addEventListener('error', function () { img.classList.add('is-loaded'); });
    }
  });
})();
